import { fetcher } from "../../utils/fetcher.js";

// Set or move the user's reminder (remindAt is an ISO date string)
export const saveReminder = (target, remindAt) =>
  fetcher.put("/api/reminders", { ...target, remindAt });

export const deleteReminder = (target) =>
  fetcher.delete(`/api/reminders?${new URLSearchParams(target)}`);
